import { render, staticRenderFns } from "./plan-view-place-card.vue?vue&type=template&id=cf3d2b12&scoped=true&"
import script from "./plan-view-place-card.vue?vue&type=script&lang=js&"
export * from "./plan-view-place-card.vue?vue&type=script&lang=js&"
import style0 from "./plan-view-place-card.vue?vue&type=style&index=0&id=cf3d2b12&lang=scss&scoped=true&"
import style1 from "./plan-view-place-card.vue?vue&type=style&index=1&id=cf3d2b12&lang=scss&scoped=true&"
import style2 from "./plan-view-place-card.vue?vue&type=style&index=2&id=cf3d2b12&lang=scss&scoped=true&"
import style3 from "./plan-view-place-card.vue?vue&type=style&index=3&id=cf3d2b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3d2b12",
  null
  
)

export default component.exports
import {QCard,QCardSection,QImg,QSeparator,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QImg,QSeparator,QBtn})
